module.exports = __webpack_public_path__ + "img/PCLaw-NEW-360px.8f96cb15.png";